import type { SelectHTMLAttributes } from 'react'
import { cn } from '@/shared/lib/cn'
import { Icon } from '@/shared/ui/icon'
import s from './Select.module.css'

type SelectOption = {
  value: string
  label: string
}

type SelectProps = Omit<SelectHTMLAttributes<HTMLSelectElement>, 'children'> & {
  options: SelectOption[]
}

export function Select({ options, className, ...rest }: SelectProps) {
  return (
    <div className={cn(s.root, className)}>
      <select className={s.select} {...rest}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <Icon name="chevron-down" size={14} className={s.chevron} />
    </div>
  )
}
